import { render, staticRenderFns } from "./ParticipantGuide.vue?vue&type=template&id=4baeb29c&scoped=true"
var script = {}
import style0 from "./ParticipantGuide.vue?vue&type=style&index=0&id=4baeb29c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4baeb29c",
  null
  
)

export default component.exports